import { Button, Typography } from '@mui/material'
import { FunctionComponent, useContext } from 'react'
import { UserDetailsContext } from '../../../../context/user-details/user-details';
import { IThirdPartyConnectionDetails } from '../../shared-services/third-party-connection-details/third-party-connection-details.model';

export const ConnectionButton: FunctionComponent<{ 
  isConnected?: boolean, 
  provider: string,
  connectionDetails: IThirdPartyConnectionDetails }> = ({ isConnected, connectionDetails, provider }) => {

  const userDetailsContext = useContext(UserDetailsContext);

  const startOAuthConnection = () => {
    // Microsoft's scope is two space-separated values, one of them a URL, so the Azure
    // authorize URL is built with proper encoding. The other providers keep their existing,
    // working URL shape untouched.
    if (provider === 'azure-carbon') {
      const params = new URLSearchParams({
        client_id: connectionDetails?.clientId ?? '',
        scope: connectionDetails?.scope ?? '',
        state: userDetailsContext.userDetails?.id ?? '',
        redirect_uri: connectionDetails?.redirectUri ?? '',
        response_type: connectionDetails?.responseType ?? 'code',
        response_mode: 'query',
        prompt: 'select_account',
      });
      window.open(`${connectionDetails?.authorizeUri}?${params.toString()}`, '_self');
      return;
    }
    // Some providers' stored authorize URL already carries a query (Sage Accounting's product
    // filter, Sage 200's API audience), so the rest is appended with & rather than starting a
    // second query string. Decided from the URL itself rather than per provider, so the next
    // provider that needs a fixed parameter does not need another special case here.
    const authorizeUri = connectionDetails?.authorizeUri ?? '';
    window.open(
      `${authorizeUri}${authorizeUri.includes('?') ? '&' : '?'}client_id=${connectionDetails?.clientId}&scope=${connectionDetails?.scope}&state=${userDetailsContext.userDetails?.id}&redirect_uri=${connectionDetails?.redirectUri}&response_type=${connectionDetails?.responseType}`, '_self')
  }

  return (
    <>
      {connectionDetails && <Button
        disableElevation
        onClick={() => startOAuthConnection()}
        sx={{ minWidth: '100px' }}
      >
        <Typography>
          {isConnected ? 'Manage Connection' : 'Connect'}
        </Typography>
      </Button>}
    </>
  )
}